import { useEffect, useState } from "react"
import bscstakeAbi from '../json/bscstake.json';
import { toast } from "react-toastify";
import { DECIMALS, DEFAULT_CHAIN, contract } from "../helper/constant";
import { getMultiCall } from "../helper/contractHelper";
import { useAccount } from "wagmi";
import { getWeb3 } from "../helper/functions";
import { ethers } from "ethers";




export const useAccountStats = (updater) => {
    let { address, isConnected } = useAccount();
    let web3 = getWeb3();

    const [stats, setStats] = useState({
        bnbbal: 0,
        userdeposit: 0,
        userwithdraw: 0,
        usercompound: 0,
        referrer: 0,
        reward: 0,
        referredCount: 0,
        refLevelCount: [0, 0, 0, 0, 0],
        weeklyreward : 0
    });


    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);



    useEffect(() => {
        const fetch = async () => {
            try {
                const data = await getMultiCall([
                    stakeContract.methods.userdeposit(address), //0
                    stakeContract.methods.userwithdraw(address), //1
                    stakeContract.methods.usercompound(address), //2
                    stakeContract.methods.accounts(address), //3
                    stakeContract.methods.getlevelrefcount(address), //4
                ]);


                let bnbbal = web3.utils.fromWei(await web3.eth.getBalance(address), 'ether');
             
                setStats({
                    bnbbal,
                    userdeposit: data[0] / Math.pow(10, DECIMALS),
                    userwithdraw: data[1] / Math.pow(10, DECIMALS),
                    usercompound: data[2] / Math.pow(10, DECIMALS),
                    referrer: data[3][0],
                    reward: data[3][1] / Math.pow(10, DECIMALS),
                    referredCount: data[3][2],
                    weeklyreward: data[3][4] / Math.pow(10, DECIMALS),
                    refLevelCount: data[4],
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }

        if (address && isConnected) {
            fetch();
        }
        else {
            setStats({
                bnbbal: 0,
                userdeposit: 0,
                userwithdraw: 0,
                usercompound: 0,
                referrer: 0,
                reward: 0,
                referredCount: 0,
                refLevelCount: [0, 0, 0, 0, 0],
                weeklyreward : 0
            })
        }
        // eslint-disable-next-line
    }, [updater, address]);

    return stats;
}

export const useRewardStats = (updater) => {
    const { address, isConnected } = useAccount();
    const web3 = getWeb3();
    const [stats, setStats] = useState({ pendingReward: 0 });

    const stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        let interval;

        const fetchRewards = async () => {
            if (!address || !isConnected) return;

            try {
                const activeOrderIds = await getMultiCall([
                    stakeContract.methods.getUserActiveOrderIds(address),
                    stakeContract.methods.pendingClaimReward(address),
                ]);

                let pendingReward = 0;

                if (activeOrderIds[0]?.length > 0) {
                    const rewardCall = activeOrderIds[0].map(orderId => 
                        stakeContract.methods.pendingReward(orderId)
                    );

                    const rewardData = await getMultiCall(rewardCall);

                    pendingReward = rewardData.reduce((acc, reward) => {
                        const value = ethers.utils.formatEther(reward[0].toString());
                        return acc + parseFloat(value);
                    }, 0);
                }

                
                pendingReward += parseFloat(activeOrderIds[1][0] / Math.pow(10,DECIMALS));

                setStats({ pendingReward });
            } catch (err) {
                console.error('Error fetching rewards:', err.message || err.reason);
                toast.error(err.message || err.reason || 'An unknown error occurred');
            }
        };

        if (address && isConnected) {
            fetchRewards(); // Fetch immediately on mount
            interval = setInterval(fetchRewards, 30000); // Fetch every 30 seconds
        } else {
            setStats({ pendingReward: 0 });
        }

        // Clear the interval on unmount or when address changes
        return () => {
            if (interval) clearInterval(interval);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [address, updater]);

    return stats;
};


export const useStakeStats = (pageId = 1) => {
    let { address, isConnected } = useAccount();
    let web3 = getWeb3();


    const [stats, setStats] = useState({
        stakeHistory: [],
        totalPages: 0,
        totalLength: 0,
        page: 1,
        loading: true,
        start: 0,
        end: 0
    });


    let stakeContract = new web3.eth.Contract(bscstakeAbi, contract[DEFAULT_CHAIN].STAKE_ADDRESS);

    useEffect(() => {
        const fetch = async () => {
            try {
                setStats({
                    ...stats,
                    loading: true
                })

                let stakeHistory = [];
                const data = await getMultiCall([
                    stakeContract.methods.getUserOrderLength(address), //0
                ]);

                var totalRecords = data[0];
                var recordsPerPage = 8;
                var totalPages = Math.ceil(totalRecords / recordsPerPage);
                var paginationInfo = calculatePagination(totalRecords, recordsPerPage, pageId);
                if (totalRecords > 0) {

                    stakeHistory = await getMultiCall([
                        stakeContract.methods.getUserOrders(address, paginationInfo.startRecord, paginationInfo.endRecord) //0
                    ]);
                }


                setStats({
                    stakeHistory: stakeHistory[0],
                    page: pageId,
                    totalLength: totalRecords,
                    totalPages,
                    loading: false,
                    start: paginationInfo.startRecord ? paginationInfo.startRecord : 0,
                    end: paginationInfo.endRecord ? paginationInfo.endRecord : 0
                })
            }
            catch (err) {
                console.log(err.message);
                toast.error(err.reason)
            }
        }

        if (address && isConnected) {
            fetch();
        }
        else {
            setStats({
                stakeHistory: [],
                totalPages: 0,
                totalLength: 0,
                page: 1,
                loading: false,
                start: 0,
                end: 0
            })
        }
        // eslint-disable-next-line
    }, [address, pageId]);

    return stats;
}


function calculatePagination(totalRecords, recordsPerPage, pageNumber) {
    // Calculate total number of pages
    var totalPages = Math.ceil(totalRecords / recordsPerPage);

    // Adjust page number if out of range
    pageNumber = Math.min(Math.max(pageNumber, 1), totalPages);

    // Calculate start and end record numbers for pagination
    var startRecord = Math.max((pageNumber - 1) * recordsPerPage, 0);
    var endRecord = Math.min(startRecord + recordsPerPage - 1, totalRecords - 1);

    // If startRecord is 0 and endRecord is still 0 (only for the first page), adjust endRecord to 1
    if (startRecord === 0 && endRecord === 0) {
        endRecord = 1;
    }

    return {
        startRecord: startRecord,
        endRecord: endRecord
    };
}
